<div class="modal fade show no-user-select" tabindex="-1" style="display: block; z-index:1050!important">
    <div class="modal-dialog modal-md modal-dialog-centered d-sm-flex align-items-sm-center">
        <div class="modal-content">
            <div class="modal-header">
                <span class="modal-title">
                    <h5 class="m-0 p-0 text-theme">Join Us</h5>
                    <p class="text-muted small m-0 p-0 text-theme">Kindly let us know your presence</p>
                </span>
                <button type="button" class="btn-close" (click)="closeAddMessageModal()"></button>
            </div>
            <div>
                <div class="modal-body">
                    <form [formGroup]="rsvpForm">
                        <div class="mb-3" *ngIf="isLoaded">
                            <label for="message" class="form-label fw-bold">Name<span
                                    class="text-danger">*</span></label>
                            <input id="message" class="form-control t-border-primary" formControlName="name"
                                aria-placeholder="Enter your name" placeholder="Enter your name" rows="3" />
                            <div *ngIf="rsvpForm.get('name')?.invalid && rsvpForm.get('name')?.touched"
                                class="text-danger">
                                Name is required.
                            </div>
                        </div>
                        <hr>
                        <div formArrayName="events">
                            <div *ngIf="isLoaded && events.controls.length==0" class="mb-3">
                                No events found
                            </div>
                            <div *ngFor="let eventGroup of events.controls; let i = index" [formGroupName]="i"
                                class="mb-4">

                                <div class="mb-2 d-inline-flex justify-content-between w-100">
                                    <span>
                                        <span class="fw-bold">{{ getEventName(eventGroup.get('eventId')?.value) }}
                                        </span>| {{
                                        getEventDate(eventGroup.get('eventId')?.value) | date:'dd-MMM-yyyy hh:mm a' }}
                                    </span>

                                    <div class="form-check form-switch mb-2">
                                        <input class="form-check-input" type="checkbox" [id]="'attend' + i"
                                            formControlName="willAttend">
                                        <label class="form-check-label" [for]="'attend' + i">
                                            {{events.at(i).get('willAttend')?.value? 'Yes':'No'}}
                                        </label>
                                    </div>
                                </div>

                                <!-- <div class="mb-3">
                                    <label for="comments" class="form-label">Comments</label>
                                    <textarea id="comments" rows="2" class="form-control t-border-primary"
                                        formControlName="comments" placeholder="Any special notes?"></textarea>
                                </div> -->

                                <hr>
                            </div>
                        </div>

                        <button type="submit" class="w-100 t-btn-primary"
                            [disabled]="rsvpForm.invalid||events.controls.length==0" (click)="submitRsvp()">
                            Confirm
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade show" style="z-index:1049!important"></div>

<div class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.2);"
    *ngIf="showToast">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content border-0 shadow rounded-4 overflow-hidden">
            <div class="modal-header py-3 px-4 d-flex justify-content-between align-items-center">
                <button type="button" class="btn-close" aria-label="Close" (click)="closeToast()"></button>
            </div>
            <div class="modal-body text-center p-4">
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <!-- <p class="fs-5 mb-0 icon" [ngClass]="textClass">{{ icon}}</p> -->
                    <img src="assets/images/success-tick-animated.gif" width="78px" height="78px">
                    <p class="mb-0 toast-message">
                        Your response has been captured. Do you want to add event to calendar?
                    </p>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" (click)="onReject()">No</button>
                <button class="btn btn-danger" (click)="onAccept()">Yes</button>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade show" *ngIf="showToast" id="toastBackdrop"></div>